import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Error, PageLayout } from 'core/components';
import { StatusCode } from 'core/constants';
import { Loader } from 'core/elements';
import { JobDetails } from 'jobs/components';
import { useGetJob } from 'jobs/hooks';

export const JobDetailsPage = () => {
  const { id } = useParams();

  const { t } = useTranslation();

  const { record, isLoading, isError } = useGetJob({ filters: { id: Number(id) } });

  return (
    <PageLayout
      title={
        record?.name ? t('titleJobDetailsWithName', { name: record.name }) : t('titleJobDetails')
      }
    >
      {isLoading && <Loader />}

      {isError && <Error statusCode={StatusCode.NOT_FOUND} />}

      {record && <JobDetails job={record} />}
    </PageLayout>
  );
};
